import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { LANG_COOKIE, type Locale } from "../../contract/auth";
import { registerFormatters } from "../../i18n/format";
import { i18nInitOptions } from "../../i18n/index";
import { resolveLocale } from "../../i18n/locale";

export { NAMESPACES, resources } from "../../i18n/resources";

/** The raw b2a_lang value, or undefined when absent or not decodable; a bad cookie must never stop the SPA. */
export function readLangCookie(cookieHeader: string = document.cookie): string | undefined {
  for (const part of cookieHeader.split(";")) {
    const [name, ...rest] = part.trim().split("=");
    if (name !== LANG_COOKIE) continue;
    try {
      return decodeURIComponent(rest.join("="));
    } catch {
      return undefined;
    }
  }
  return undefined;
}

/** Cookie -> navigator.language -> de. */
export function initialLocale(): Locale {
  return resolveLocale(readLangCookie(), navigator.language);
}

/** Writes the b2a_lang cookie for one year and switches i18next. */
export function setLocale(locale: Locale): Promise<unknown> {
  document.cookie = `${LANG_COOKIE}=${locale}; Max-Age=31536000; Path=/; SameSite=Lax`;
  document.documentElement.lang = locale;
  return i18next.changeLanguage(locale);
}

/** Initialises the SPA's i18next singleton with the shared catalogues and registers the formatters once. */
export async function setupI18n(locale: Locale = initialLocale()) {
  document.documentElement.lang = locale;
  const t = await i18next.use(initReactI18next).init(i18nInitOptions(locale));
  registerFormatters(i18next);
  return t;
}

export { i18next };
